<template>
  <div>
    <v-menu
      v-model="showFontDialog"
      :close-on-content-click="false"
      max-width="380"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-list-tile
          @click.stop="showFontDialog=true"
        >
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon class="mr-1">font_download</v-icon> Police</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>

      <v-card width="380">
        <v-layout
          row wrap
        >
          <v-flex xs12 class="pa-3">
            <v-layout align-end justify-space-between fill-height>
              <h3>Police de caractères</h3>
              <v-btn icon @click="showFontDialog=false" >
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>

          <v-card-title primary-title class="pt-0 mt-0 pb-0 mb-0">
            <h4 class="font-weight-thin font-italic">Sélectionner une police de caractères, puis fermer cette popup pour sauvegarder.</h4>
            <h5>Police par défaut pour ce template: <span :style="{'font-family': defaultFont}"> {{defaultFont}}</span></h5>
          </v-card-title>

          <v-card-text>

            <v-radio-group v-model="cvFont1" :mandatory="false">
              <v-radio
                v-for="font in fonts"
                :key="font.title"
                :label="font.title"
                :value="font.fontclass"
                :style="{'font-family': font.fontclass}"
              >
              </v-radio>
            </v-radio-group>
            <p>(Police sélectionnée : <span :style="{'font-family': cvFont1}">{{ cvFont1 }})</span></p>

          </v-card-text>

        </v-layout>
      </v-card>
    </v-menu>
  </div>


</template>

<script>


 import { mapActions, mapState } from 'vuex';

 export default {

   data () {
     return {
       showFontDialog: false,
       fonts: [
         {title: 'Lato: sélectionner cette police', fontclass: "'Lato'"},
         {title: 'Montserrat: sélectionner cette police', fontclass: "'Montserrat'"},
         {title: 'Roboto: sélectionner cette police', fontclass: "'Roboto'"},
         {title: 'Times New Roman: sélectionner cette police', fontclass: "'Lora'"},
         {title: 'Indy Flower: sélectionner cette police', fontclass: "'Indie Flower'"},
         {title: 'Old Standard: sélectionner cette police', fontclass: "'Old Standard TT'"},
       ],
       radios: 'radio-1',
     }
   },
   methods: {
     ...mapActions('cvVuex', [
       'getCvModelObject',
       'updateCvModelObject',
     ]),
   },
   computed: {
     defaultFont: function() {
       var defaultTemplate = this.$store.getters['cvVuex/getDefaultTemplate']
       return defaultTemplate.default_cv_font1
     },
     cvFont1: {
       get() {
         console.log("***************************  cvFont1  ----")

         // Récupère la font par DEFAUT du template associé
         var defaultTemplate = this.$store.getters['cvVuex/getDefaultTemplate']
         console.log('FONT1 par defaut : ' + defaultTemplate.default_cv_font1)

         // récupère la font du template associé
         var theTemplate = this.$store.getters['cvVuex/getRelatedTemplate']
         console.log('FONT1 user selected : ')
         console.log(theTemplate)
         console.log('--- get de la FONT1 : ' + theTemplate.cv_font1)

         // Si aucune font n'a été sélectionnée par l'utilisateur :
         // fallback sur la font par défaut du template.
         if (!theTemplate.cv_font1) {
           console.log("FONT : Pas de font choisie par le user. Fallback")
           return defaultTemplate.default_cv_font1
         } else {
           console.log("FONT : le user a sélectionné une font")
           return theTemplate.cv_font1
         }
       },
       set(value) {
         // NOTE : on envoie un objet qui est ensuite décomposé dans la mutation MODEL_OBJECT_2
         // noter le namespace 'module/MUTATION'
         this.$store.commit( 'cvVuex/CV_MODEL_UPDATE_FONT', value)
       }
     },
     ...mapState('cvVuex', [
       'vuexCvModel',
     ]),
   },
   watch: {
     showFontDialog(val) {
       /* Astuce de jon en personne!!! https://github.com/vuetifyjs/vuetify/issues/3478 */
       if(!val) {
         console.log('======== Update de la font ========');
         var theTemplate = this.$store.getters['cvVuex/getRelatedTemplate']
         console.log('the template : ')
         console.log(theTemplate)
         this.updateCvModelObject({ 'cvid':this.vuexCvModel.id,
                                    'data_sent': { 'mod_m2m': theTemplate }});
       }
     }
   },
 }
</script>

<style>
  .font-roboto {
    font-family: 'Montserrat', sans-serif;
  }
</style>
